module.exports = __webpack_public_path__ + "static/media/astro-logo.2aefa988.svg";